import styled from 'styled-components';
import { Button, Divider } from 'antd';

export const ToolbarWrapper = styled.div<{ $top?: number }>`
  display: flex;
  flex-direction: row;
  padding: 3px;
  margin: 0;
  color: #333;
  background-color: white;
  position: sticky;
  top: ${({ $top }) => `${$top || 60}px`};
  z-index: 12;
  height: 44px;
  padding-right: 10px;
  box-shadow:
    rgb(14 63 126 / 4%) 0 0 0 1px,
    rgb(42 51 69 / 4%) 0 1px 1px -0.5px,
    rgb(42 51 70 / 4%) 0 3px 3px -1.5px,
    rgb(42 51 70 / 4%) 0 6px 6px -3px,
    rgb(14 63 126 / 4%) 0 12px 12px -6px,
    rgb(14 63 126 / 4%) 0 24px 24px -12px;
`;

export const StyledDivider = styled(Divider)`
  height: 100%;
`;

export const StyledButton = styled(Button)`
  &:disabled {
    .anticon {
      opacity: 0.3;
    }
  }
`;
